import { isAfter, isSameDay } from 'date-fns';

import type { Appointment } from '../../react-query/useAppointments';

export const getNextAppointment = ({
  appointments,
  selectedDate,
}: {
  appointments: Appointment[];
  selectedDate: Date | null;
}) => {
  const today = new Date();

  // @ts-expect-error TS(2345): Argument of type 'Date | null' is not assignable t... Remove this comment to see the full error message
  if (!isSameDay(today, selectedDate)) {
    return;
  }
  /**
   * This is the dependent on appointments being in order.
   * Prioritize the first appointment with a start/end date that contains the current date-time.
   * Then check for an appointment w/ a start date after the current date time.
   * If this is the case, then the first priority is no longer possible.
   */
  const nextAppointment = appointments.find(
    (appointment) =>
      appointment.appointment.start &&
      isAfter(new Date(appointment.appointment.start), today),
  );
  if (nextAppointment) {
    return nextAppointment.appointment.unifiedId;
  }
  // Default to last appointment
  return appointments[appointments.length - 1]?.appointment.unifiedId;
};
